import React, { useEffect, useRef, useState } from "react";
import ApiService from "../../services/api-service";
import Loader from "../Loader";
import { useDispatch, useSelector } from "react-redux";
import { updatecount } from "../../action/adv";
import { start } from "../../action/streamSong";
import { HMS } from "../../constants/function";
import AudPlayer from "../AudPlayer";
import ImageAdv from "../ImageAdv";
import "./index.scss";
import { getUserId, putAdRecors } from "../../constants/function";
import { Typography } from "@mui/material";
import { TrackChanges } from "@mui/icons-material";

export default function Advertisement() {
  const userId = getUserId();
  const videoRef = useRef(null);
  const [seconds, setSeconds] = React.useState(30);
  const [loading, setLoading] = useState(false);
  const { index, songs, track, prevIndex, pos } = useSelector(
    (state) => state.streamSong
  );
  const { count } = useSelector((state) => state.adv);
  const dispatch = useDispatch();
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [add, setAdd] = useState();
  const { isStream } = useSelector((state) => state.stream);
  const [addCount, setAddCount] = React.useState();

  const getAddCount = async () => {
    try {
      setLoading(true);
      const response = await ApiService.ADD_COUNT();
      setAddCount(response["result"]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getAdd = async () => {
    try {
      // const IsStream = isStream
      //   ? isStream
      //   : localStorage.getItem("showAd")
      //   ? true
      //   : false;
      setLoading(true);
      const response = await ApiService.ADD(`&livestream=${isStream}`);
      if (response["result"].length === 0) dispatch(updatecount(0));

      setAdd(response["result"]);
      putAdRecors({
        eventType: "adView",
        adId: response["result"].id,
        userId: userId,
        metadata: {
          platform: "web",
        },
        viewLivestream: isStream,
        timestamp: new Date().getTime(),
        orderNo: response["result"]?.orderNo,
        adType: response["result"].adType,
      });
      // localStorage.removeItem("showAd");
      if (count && track) {
        // console.log(count, "::count::");
        track.pauseProcessAudioBuffer();
        dispatch(
          start({
            index: index,
            songs: songs,
            prevIndex: prevIndex,
            pos: pos,
            track: track,
          })
        );
      }
      if (isStream) {
        const adContainer = document.getElementById("_ad_container");
        if (adContainer) {
          adContainer.style.height = "calc(100vh - 60px)";
        }
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    getAdd();
    getAddCount();
  }, []);

  // useEffect(() => {
  //   if (seconds > 0) {
  //     const timerId = setTimeout(() => {
  //       setSeconds(seconds - 1);
  //     }, 1000);
  //     return () => clearTimeout(timerId);
  //   }
  // }, [seconds]);

  var timerId;
  useEffect(() => {
    if (seconds > 0) {
      const timerId = setTimeout(() => {
        setSeconds(seconds - 1);
      }, 1000);
    }
    // if (seconds === 0) {
    //   dispatch(updatecount(0));
    // }
    return () => clearTimeout(timerId);
  }, [currentTime]);

  function handleSeeking(event) {
    const video = videoRef.current;
    const currentTime = video?.currentTime;
    const previousTime = event.target.dataset.previousTime;

    if (currentTime > previousTime) {
      video.currentTime = previousTime;
    }
    event.target.dataset.previousTime = video?.currentTime;
  }

  window.onkeydown = vidCtrl;

  function vidCtrl(e) {
    const vid = document.querySelector("video");
    const key = e.code;

    if (key === "Space") {
      e.preventDefault();

      if (vid?.play || vid?.ended) {
        // console.log("play - pause is desable");
        vid.pause(false);
      }
    }
  }
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.addEventListener("ended", () => {
        // if (
        //   track ||
        //   songs.length > 0 ||
        //   (track && songs.length > 0 && count % 3 !== 0)
        // ) {
        //   track.resumeProcessAudioBuffer();
        //   console.log(track, count, "::track::");
        // }
        dispatch(updatecount(0));
      });
    }
  }, [add]);

  useEffect(() => {
    return () => {
      window.onkeydown = null;
    };
  }, []);

  const currentDuration = () => {
    setDuration(videoRef.current.duration);
  };

  const timeUpdate = () => {
    setCurrentTime(videoRef.current.currentTime);
  };

  const reverseDuration = () => {
    const reversedDuration = (duration - currentTime).toFixed();
    return reversedDuration;
  };

  const handleSkip = (duration) => {
    if (duration > 29) dispatch(updatecount(0));
  };

  return (
    <>
      {add && add?.length === 0 ? null : (
        <div
          className="_ad_container"
          id="_ad_container"
          onClick={() => {
            putAdRecors({
              eventType: "adClick",
              adId: add?.id,
              userId: userId,
              metadata: {
                platform: "web",
              },
              timestamp: new Date().getTime(),
              orderNo: add?.orderNo,
              adType: add.adType,
            });
            let a = document.createElement("a");
            a.target = "_blank";
            a.href = add.redirectUrl;
            a.click();
            a.remove();
          }}
        >
          {add?.type === "video" ? (
            <div className="ad_time">
              <Typography
                className={"fs-20" + (seconds == 0 ? " _cp" : "")}
                onClick={(e) => {
                  e.stopPropagation();
                  handleSkip(videoRef.current.currentTime);
                }}
              >
                {/* {`${HMS(reverseDuration())}` === "undefined"
                  ? "00 : 00"
                  : videoRef.current.currentTime < 30
                  ? `${HMS(reverseDuration())}`
                  : "Skip"} */}
                {`${HMS(seconds)}` === "0 sec" ? "Skip" : `${HMS(seconds)}`}
              </Typography>
            </div>
          ) : null}

          {add && add?.url && add?.type == "video" ? (
            <>
              <video
                className="video_container"
                controls
                // poster="https://picsum.photos/800/450"
                data-setup="{}"
                src={add["url"]}
                // src="/Videos/movie.mp4"
                ref={videoRef}
                controlsList="nodownload nofullscreen noremoteplayback noplaybackrate nopacture "
                disablePictureInPicture
                onSeeking={handleSeeking}
                autoPlay
                currentTime="false"
                onLoadedMetadata={currentDuration}
                onTimeUpdate={timeUpdate}
                // playsinline
              >
                {/* <source src="movie.mp4" type="video/mp4" /> */}
              </video>
              <div className="transferent"></div>
            </>
          ) : add && add.url && add.type == "image" ? (
            <ImageAdv
              url={add["url"]}
              type={add.type}
              href={add.redirectUrl ? add["redirectUrl"] : ""}
              time={addCount ? addCount["imgAdDuration"] : 30}
            />
          ) : add && add.url && add.type == "audio" ? (
            <AudPlayer
              url={add["url"]}
              image={add["thumbnailImg"]}
              type={add.type}
              href={add.redirectUrl ? add["redirectUrl"] : ""}
            />
          ) : null}

          {loading ? <Loader /> : null}
        </div>
      )}
    </>
  );
}
